import { getSurvivorGameplayPerkId } from './survivorPerkEquivalents'

// Global perk strength for Loadout Craft: Otzdarva tierlist order plus local gameplay notes.
const SURVIVOR_PERK_STRENGTH_OVERRIDES = {
  ace_in_the_hole: 42,
  adrenaline: 82,
  aftercare: 50,
  alert: 70,
  autodidact: 52,
  balanced_landing: 72,
  boil_over: 48,
  bond: 74,
  borrowed_time: 54,
  botany_knowledge: 72,
  breakdown: 56,
  calm_spirit: 44,
  dance_with_me: 58,
  dark_sense: 46,
  dead_hard: 84,
  decisive_strike: 96,
  deja_vu: 82,
  deliverance: 86,
  detectives_hunch: 58,
  distortion: 68,
  diversion: 32,
  empathy: 62,
  head_on: 54,
  hope: 70,
  iron_will: 68,
  kindred: 88,
  leader: 55,
  left_behind: 36,
  lightweight: 56,
  lithe: 84,
  no_mither: 15,
  no_one_left_behind: 46,
  object_of_obsession: 44,
  open_handed: 54,
  pharmacy: 38,
  plunderers_instinct: 36,
  poised: 46,
  premonition: 28,
  prove_thyself: 58,
  quick_and_quiet: 58,
  resilience: 84,
  saboteur: 62,
  self_care: 40,
  slippery_meat: 34,
  small_game: 42,
  sole_survivor: 34,
  solidarity: 38,
  spine_chill: 48,
  sprint_burst: 92,
  stake_out: 58,
  streetwise: 52,
  technician: 30,
  tenacity: 56,
  this_is_not_happening: 35,
  unbreakable: 92,
  up_the_ante: 44,
  urban_evasion: 42,
  vigil: 64,
  wake_up: 44,
  well_make_it: 84,
  were_gonna_live_forever: 74,
  windows_of_opportunity: 88,
  buckle_up: 52,
  flip_flop: 50,
  mettle_of_man: 52,
  baby_sitter: 62,
  camaraderie: 48,
  second_wind: 58,
  better_together: 58,
  fixated: 62,
  inner_strength: 62,
  breakout: 64,
  any_means_necessary: 60,
  lucky_break: 72,
  off_the_record: 88,
  red_herring: 28,
  for_the_people: 68,
  soul_guard: 62,
  blood_pact: 42,
  repressed_alliance: 36,
  desperate_measures: 64,
  built_to_last: 62,
  visionary: 32,
  appraisal: 42,
  deception: 48,
  power_struggle: 52,
  fast_track: 66,
  self_preservation: 40,
  smash_hit: 50,
  bite_the_bullet: 50,
  blast_mine: 62,
  counterforce: 42,
  flashbang: 72,
  resurgence: 94,
  rookie_spirit: 34,
  circle_of_healing: 78,
  shadow_step: 80,
  clairvoyance: 46,
  exponential: 76,
  corrective_action: 54,
  overcome: 76,
  dark_theory: 38,
  empathic_connection: 56,
  parental_guidance: 38,
  inner_focus: 42,
  residual_manifest: 58,
  overzealous: 68,
  better_than_new: 38,
  hyperfocus: 76,
  low_profile: 34,
  reactive_healing: 42,
  reassurance: 78,
  wiretap: 70,
  potential_energy: 42,
  fogwise: 58,
  quick_gambit: 64,
  background_player: 78,
  blood_rush: 54,
  cut_loose: 48,
  friendly_competition: 38,
  teamwork_collective_stealth: 36,
  teamwork_power_of_two: 36,
  made_for_this: 72,
  scavenger: 62,
  troubleshooter: 72,
  dramaturgy: 68,
  scene_partner: 44,
  plot_twist: 72,
  chemical_trap: 64,
  light_footed: 46,
  lucky_star: 50,
  boon_illumination: 28,
  champion_of_light: 64,
  deadline: 34,
  invocation_weaving_spiders: 42,
  strength_in_shadows: 64,
  wicked: 58,
  bardic_inspiration: 48,
  mirrored_illusion: 36,
  still_sight: 48,
  specialist: 56,
  finesse: 78,
  hardened: 42,
  exultation: 56,
  eyes_of_belmont: 54,
  moment_of_glory: 52,
  clean_break: 50,
  treacherous_crows: 18,
  shoulder_the_burden: 78,
  do_no_harm: 50,
  duty_of_care: 48,
  rapid_response: 52,
  apocalyptic_ingenuity: 52,
  come_and_get_me: 50,
  teamwork_toughen_up: 42,
  conviction: 58,
  last_stand: 48,
  teamwork_throw_down: 42,
  ghost_notes: 54,
  one_two_three_four: 38,
  road_life: 46,
  bada_bada_boom: 46,
  change_of_plan: 52,
  teamwork_full_circuit: 26,
  extrasensory_perception: 78,
  teamwork_soft_spoken: 32,
  we_see_you: 46,
  a_place_for_us: 38,
  five_moves_ahead: 62,
  flow_state: 82,
  wide_open_throttle: 76,
  lend_a_hand: 58,
  cross_examination: 66
}

const STRENGTH_TIERS = [
  { label: 'S', min: 88 },
  { label: 'A', min: 76 },
  { label: 'B', min: 64 },
  { label: 'C', min: 50 },
  { label: 'D', min: 34 },
  { label: 'F', min: 0 }
]

function clampStrengthScore (score) {
  const numericScore = Number(score)
  if (!Number.isFinite(numericScore)) return 50
  return Math.max(0, Math.min(100, Math.round(numericScore)))
}

export function getSurvivorPerkStrengthScore (perkOrId, fallbackScore) {
  const perkId = getSurvivorGameplayPerkId(typeof perkOrId === 'string' ? perkOrId : perkOrId && perkOrId.id)
  const fallback = fallbackScore === undefined && perkOrId && typeof perkOrId === 'object'
    ? perkOrId.soloQueueScore
    : fallbackScore
  const score = perkId && SURVIVOR_PERK_STRENGTH_OVERRIDES[perkId] !== undefined
    ? SURVIVOR_PERK_STRENGTH_OVERRIDES[perkId]
    : fallback
  return clampStrengthScore(score === undefined ? 50 : score)
}

export function getSurvivorPerkStrengthTier (perkOrScore, fallbackScore) {
  const score = typeof perkOrScore === 'number'
    ? clampStrengthScore(perkOrScore)
    : getSurvivorPerkStrengthScore(perkOrScore, fallbackScore)
  const tier = STRENGTH_TIERS.find(tier => score >= tier.min)
  return tier ? tier.label : 'C'
}

export { SURVIVOR_PERK_STRENGTH_OVERRIDES }
